// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DJK4","content":"styles_content__UTS55","tableWrap":"styles_tableWrap__2gOWZ"};